import React from 'react'
import "../assets/pages-css/home.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Footer from '../components/globals/home/footer';
import Copyright from '../components/globals/home/copyright';
import Header from '../components/globals/home/header';

const DataDeletionPolicy = () => {

  return (
    <>
      <Header />
      <div className='container mt-4 mb-4'>
        <h1>SharkSkillz Data Deletion Policy</h1>
        <p>SharkSkillz is committed to respecting your privacy and protecting your personal data. This Data Deletion Policy explains your rights regarding data deletion and the procedures we have in place for deleting data collected via the SharkSkillz app.</p>

        <h2>1. Scope</h2>
        <p>This policy applies to all users of the SharkSkillz app who wish to request the deletion of their personal data from our systems.</p>

        <h2>2. Types of Data Eligible for Deletion</h2>
        <p>Users can request the deletion of personal data, including but not limited to:</p>
        <ul>
          <li>Profile information (e.g., name, email address, contact details)</li>
          <li>Educational progress data and achievements</li>
          <li>Interaction history within SharkSkillz</li>
          <li>Any other data that identifies you personally</li>
        </ul>

        <h2>3. Data Deletion Process</h2>
        <p>To request the deletion of your data, please follow the steps outlined below:</p>
        <ol>
          <li><strong>Contact Request:</strong> Submit a data deletion request to SharkSkillz's support team through email at <a href="mailto:skillz@sharkskillz.com">skillz@sharkskillz.com</a>.</li>
          <li><strong>Verification:</strong> To protect your privacy, we will take steps to verify your identity before complying with the request. You may be asked to provide information necessary for verification purposes.</li>
          <li><strong>Processing Time:</strong> Once your identity is confirmed, we will process your data deletion request. This process typically takes 30 days to complete. We will keep you updated via your registered email address.</li>
        </ol>

        <h2>4. Consequences of Data Deletion</h2>
        <p>Deleting your personal data is permanent and irreversible. Please consider the following before proceeding:</p>
        <ul>
          <li><strong>Loss of Access:</strong> You may lose access to the SharkSkillz app and any accumulated data, including progress or achievements.</li>
          <li><strong>Service Functionality:</strong> Certain features may become unavailable, and the quality of user experience might change.</li>
        </ul>

        <h2>5. Exceptions</h2>
        <p>Certain data may not be immediately deleted due to:</p>
        <ul>
          <li><strong>Legal Obligations:</strong> We may need to retain some data for compliance with legal obligations or resolving disputes.</li>
          <li><strong>Security Reasons:</strong> Data may temporarily remain in backup copies that are part of our disaster recovery protocols.</li>
        </ul>

        <h2>6. Changes to This Policy</h2>
        <p>SharkSkillz reserves the right to modify this Data Deletion Policy at any time. We will notify you of any significant changes through appropriate communication channels.</p>

        <h2>7. Contact Information</h2>
        <p>If you have questions or concerns about this Data Deletion Policy or the deletion process, please contact our support team at <a href="mailto:skillz@sharkskillz.com">skillz@sharkskillz.com</a>.</p>

        <p>Thank you for using SharkSkillz. We value your privacy and are committed to providing a transparent and straightforward approach to data deletion.</p>
      </div>
      <Footer />
      <Copyright />
    </>
  )
}

export default DataDeletionPolicy;